<template>
  <div id="ebUploadImage">
    <el-button
      @click="handleUploadClick"
      v-bind:style="{ width: width, height:height }"
      v-bind:class="UploadClass"
    >{{text}}</el-button>
    <input v-show="false" name="myFile" @change="handleMyFileChange" type="file">
  </div>
</template>
<script>
import $ from 'jquery';
import { uploadFile } from '@/plugins/upload-file';
// import { baseURL } from '@/plugins/axios';
export default {
  name: 'ebUploadImage',
  props: {
    width: {
      default: '102px'
    },
    height: {
      default: '30px'
    },
    text: {
      default: '上传图片'
    },
    UploadClass: {
      default: 'eb-button-orange'
    },
    UploadName: {
      default: 'myFile'
    },
    uploadUrl: {
      type: String,
      required: true
    },
    uploadData: {
      type: Object
    }
  },
  data() {
    return { uploadPercentage: 0 };
  },
  methods: {
    handleUploadClick: function(evt) {
      $(evt.target)
        .parents('#ebUploadImage')
        .find('input')
        .click();
    },
    handleMyFileChange: function(evt) {
      if (!this.validate(evt)) {
        return;
      }
      this.$root.layout.isLoading = true;
      uploadFile(
        evt.target,
        this.uploadUrl,
        this.uploadData,
        res => {
          this.$root.layout.isLoading = false;
          let { data } = res;
          if (data.error) {
            this.$message.error('上传失败');
          } else {
            this.$emit('onUploadSuccess', {
              filePath: data,
              data: data
            });
          }
        },
        complete => {
          this.uploadPercentage = complete;
        }
      );
    },
    validate: function(evt) {
      let maxSize = 1024 * 1024 * 10;
      let value = evt.target.files['0'].name;
      let size = evt.target.files['0'].size;
      var reg = /\.tiff$|\.tif$|\.bmp$|\.jpg$|\.jpeg$|\.gif$|\.png$/i;
      if (!reg.test(value)) {
        this.$message.error('您上传的文件类型不正确');
        return false;
      }
      if (size > maxSize) {
        this.$message.error('请上传小于10M的附件');
        return false;
      }
      return true;
    }
  }
};
</script>
<style lang="less" scoped>
#ebUploadImage {
  display: inline-block;
}
</style>
